
















import {
  Vue, Component, Prop
} from "@/shared/vuepack";
import {
  HsabExpenseReimbursementResponse,
  HsabExpenseResponse,
  WexExpenseAccountType
} from "@/shared/types";
import CurrencyAmount from "@/shared/components/ui/CurrencyAmount.vue";
import Pill from "@/shared/components/ui/Pill.vue";
import HsabExpenseEvidence from "@/employee/components/landing-pages/hsabank/expense/HsabExpenseEvidence.vue";
import { useHsabExpenseStore } from "@/employee/store/hsabExpense";

@Component({
  components: { HsabExpenseEvidence, Pill, CurrencyAmount }
})
export default class HsabExpenseCardRowExpenseEvidence extends Vue {

  @Prop({ required: true })
  expense: HsabExpenseResponse;

  @Prop({ required: true })
  reimbursement: HsabExpenseReimbursementResponse;

  @Prop({ required: true })
  expenseCategory: WexExpenseAccountType;

  hsabExpenseStore = useHsabExpenseStore();

  @Prop()
  stagedFilesForUpload;

  get uploadFileCount () {
    let count = 0;
    if (this.expense && this.expense.expenseEvidence) {
      count += this.expense.expenseEvidence.length;
    }
    if (this.stagedFilesForUpload) {
      count += this.stagedFilesForUpload.length;
    }
    return count;
  }

  get isExpenseSubmitted (): boolean {
    return this.expense && this.expense.isSubmitted;
  }

  get isExpenseSubmittedToHsa (): boolean {
    return this.expense &&
        this.expense.isSubmitted &&
        this.expense.reimbursement &&
        this.expense.reimbursement.isHsaReimbursement;
  }

  get isAddingReceiptsAllowed () {
     return this.hsabExpenseStore.isAddingClaimReceiptsAllowed(this.reimbursement);
  }

  addFiles (files) {
    this.$emit("staged-files-updated", files);
  }
}
